/**
 * Hands the scroll offset over when Horizon swaps scroll containers at 990px.
 *
 * Below 990px the window scrolls the document. At and above it, base.css puts
 * `height: 100dvh; overflow: hidden` on html and body and makes `.page-wrapper` the
 * scroller instead. Crossing that line leaves the offset stranded on whichever element
 * has just stopped scrolling, and the wide direction is the damaging one: the window
 * keeps the offset it had while narrow, so the viewport stays parked below a document
 * that is now exactly one viewport tall and cannot scroll back. The page looks blank and
 * dead until a reload — which is what a reader sees if they resize the window, rotate a
 * tablet, or open dev tools wide.
 *
 * Moving the offset across as the line is crossed fixes that, and keeps the reader's
 * place rather than throwing them to the top. The two layouts are not identical, so the
 * carried pixel offset is an approximation — but it lands in the same part of the page,
 * which is the point.
 *
 * Load with type="module" so nothing here reaches the global scope.
 */

const WIDE = '(min-width: 990px)';

/**
 * Scrolls without the smooth behaviour base.css sets on both containers — this is a
 * layout correction, not a navigation, and animating it would show the broken frame.
 */
function jump(el, top) {
  if (el === window) el.scrollTo({ top, behavior: 'instant' });
  else el.scrollTo({ top, left: 0, behavior: 'instant' });
}

function handOver(wide) {
  const wrapper = document.querySelector('.page-wrapper');
  if (!wrapper) return;

  // Read both before writing either: the element losing the offset is the one that still
  // has it, and which that is depends on the direction of travel.
  const from = wide ? window.scrollY : wrapper.scrollTop;
  if (!from) return;

  if (wide) {
    jump(window, 0);
    jump(wrapper, from);
  } else {
    jump(wrapper, 0);
    jump(window, from);
  }
}

const query = window.matchMedia(WIDE);

// The media query flips before the browser has laid the new container out, so wait a
// frame — reading or writing scrollTop any earlier lands on the old geometry.
const onChange = (event) => requestAnimationFrame(() => handOver(event.matches));

if (query.addEventListener) query.addEventListener('change', onChange);
else query.addListener(onChange); // Safari < 14
